import { render, staticRenderFns } from "./CategoryCard.vue?vue&type=template&id=ff5e6ff0&"
import script from "./CategoryCard.vue?vue&type=script&lang=js&"
export * from "./CategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports